export enum LinkedToEnum {
  ORDER = 'order',
  RECTIFICATION = 'rectification'
}
